module.exports = __webpack_public_path__ + "static/utility-tracker-mobile-plp-8bbd8b8f3c034d4831390063baa5fe98.png";